import React, { Component, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "../../Styles/globalStyle.css";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import useLogIcon from "../../../Hooks/useLogIcon.js";
import CheckBox from "../../Commands/CheckBox/CheckBox";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import uuid from "react-native-uuid";

export default function CreateAnAccount(props) {
  const isInputValid = useValidationInput();
  const axiosOperation = useAxiosOperation();
  const getLogIcon = useLogIcon();
  const  [user, setUser] = useState({ 
    id: uuid.v4(),
    fullName : "",
    siteName : "",
    email : "",
    password : "",
    confirmPassword : "",
    reset : false,
    signed: false,
    errors:[],
    loading:false,
    company: {siteName:new URLSearchParams(useLocation().search).get("siteName"), profils:[]}
 })

  const fireEventKeyPress = (e, detail, typeValidations) => {
     
    var userData = JSON.parse(JSON.stringify(user));
  
    userData.errors = userData.errors.filter(error => error.id != detail.id )

    if(typeValidations,  !isInputValid({value: e.key}, typeValidations).isValid) {
      e.preventDefault()
    }
    setUser(userData);
  }

  const validInput = (value, detail, typeValidation, userData) => {
    const eventResponse = isInputValid({value: value}, typeValidation);
    if(eventResponse.isValid) {
      userData.errors = userData.errors.filter(error => error.id != detail.id )
    }
    else {
      userData.errors.push({id:detail.id
        , text: eventResponse.type == "EMAIL" ? "The email is invalid" : "The field is required".replace("field", detail.name)})
    }
  }

  const fireOtherEvent = (e, detail, typeValidation) => {
  
    var userData = JSON.parse(JSON.stringify(user));
    //const eventResponse = isInputValid({value: e.target.value}, typeValidation);
    
    validInput(e.target.value, detail, typeValidation, userData) 
    setUser(userData);
  }

  const onCreate = () => {
  
    var userData = JSON.parse(JSON.stringify(user));
    

    validInput(user.fullName, {id:"FullName", name:getFullName() }, [{type :"REQUIRE"}], userData) 
    validInput(user.siteName, {id:"SiteName", name:getSiteName() }, [{type :"REQUIRE"}], userData) 
    validInput(user.email, {id:"Email", name:"Email" }, [{type :"REQUIRE"}], userData) 
    validInput(user.password, {id:"Password", name:"Password" }, [{type :"REQUIRE"}], userData)
    validInput(user.confirmPassword, {id:"ConfirmPassword", name:"Confirmation" }, [{type :"REQUIRE"}], userData) 

    
    if (user.password != user.confirmPassword)
      userData.errors.push({id:"ConfirmPassword", text:"Your password and the confirmation do not match" })
      
    if (user.password.length < 4)
      userData.errors.push({id:"Password", text:"Password must be at least 4 character" })
    
    if (!/\d/.test(user.password) || !isNaN(user.password))
      userData.errors.push({id:"Password", text:"Password must includes characters and numbers" })


    userData.email = userData.email.toLocaleLowerCase()
    
    if (userData.errors.length == 0) {
      setUser({...userData, loading:true })
      axiosOperation({method:"POST"
        , url: user.company.siteName == null ? "https://flex-services.onrender.com/user/" : "https://flex-services.onrender.com/profilUser/"
        , body: user.company.siteName == null ? {...userData, isUpdate:false, resetPassword:false,companyId:user.companyId, log: undefined, company:undefined} :
        {id:userData.id,firstName:userData.fullName, lastName:userData.siteName, email:userData.email,isUpdate:false, password:userData.password
          ,siteName:user.company.siteName, resetPassword:false,companyId:user.companyId, profilGlobalId:userData.profilGlobalId }
        }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data
              setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style, activeResendEmail:result.activeReSendEmail}})
            }
            else {
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}, activeResendEmail:undefined}})
            }
          })
      
    }
    else 
      setUser(userData);
  }

  const refreshForm = () => {
  
    const userData = { 
      id: uuid.v4(),
      fullName : "",
      siteName : "",
      email : "",
      password : "",
      confirmPassword : "",
      reset : false,
      signed: false,
      errors:[]
    }
   
    setUser(userData);
  }

  const getError = (id) => {
    const error =  user.errors.filter(item => item.id == id)[0]
    return <div style={{border:"none", backgroundColor:"transparent", userSelect:"none",
     paddingTop:"0px", marginTop:"0px", height:"15px",  color: "rgb(206, 17, 38)", fontSize: 10}} 
     >{error ? error.text: ""}</div>
    
  };
  const isNewRegister = !(user.log && user.log.activeResendEmail) 

  const canClick = user.signed && user.errors.length == 0  && !user.loading

  useEffect(() => {
    if (user.company.siteName != null) {
     
      var userData = JSON.parse(JSON.stringify(user));
      setUser({...userData, loading:true })
      axiosOperation({method:"GET"
        , url: "https://flex-services.onrender.com/user/"+ user.company.siteName + "/"
        , body: {confirmed:true, nTry:0}
        }).then(response => 
          { 
            var company = user.company
            
            if(response.managedError) {
              const result = JSON.parse(JSON.stringify(response.result.data))
              
              if (result.length > 0) {
                company = {...user.company,  profils:result.map( item=>  {return {id:JSON.parse(item.profil).globalId
                  , item:JSON.parse(item.profil).key.value
                  , companyId:item.companyId}})}
                
                userData["profilGlobalId"] = company.profils[0]["id"]
                userData["profilItem"] = company.profils[0]["item"]
                userData["companyId"] = company.profils[0]["companyId"]
              }
              
            }
            
            setUser({...userData, company:company})
          })
    } 
  }, []);

  const getFullName = () => {
  
   if (user.company.siteName != null)
    return "First Name"
  else
    return "Full Name"
  }

  const getSiteName = () => {
  
    if (user.company.siteName != null)
     return "Last Name"
   else
     return "Site Name"
   }
  
  return (
    <div style = {{ marginLeft:"auto",  marginRight:"auto",width:"250px"
    , padding: "20px", borderRadius: "4px"
    , marginTop:"50px" , backgroundColor: "white" }}>
      <div style = {{ display:"flex"  }}>
        <span style = {{ fontFamily:"Verdana",fontSize:"16px"  }} >Register</span>
        <div style = {{ marginLeft:"10px"  }}>
        { user.loading ? <SpinnerIcon /> : (user.log ? getLogIcon(user.log.type) : null)}
        </div>
      </div>
      <div style = {{ marginBottom:"5px"  }}>
        { user.log && <span style = {user.log.style} >{user.log.text}</span>}
      </div>
      {user.company.profils.length > 0 && <div style = {{ width:"150px"}}>
         <DropDownListNew
            fontSize={"14px"}
            currentData={user.company.profils}
            id={"ProfilsList"}
            initialValue={user.profilItem}
            //multiSelection = {true}
            //selectedValues = {[]}
            onDropDownItemClick={(itemSelected) => setUser({...user, profilGlobalId:itemSelected.id, profilItem:itemSelected.item}) }
             onlyLabel={false}/>
         </div>
      }
      
      {isNewRegister && <input id="FullName" type="textBox" placeholder={getFullName()} value={user.fullName}  
          onChange={(e)=> setUser({...user, fullName:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"FullName", name:getFullName() }, [{type :"REQUIRE"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"FullName" })}
          style = {{marginTop:"10px"  }}
          className="input connexionInput" />}
        {isNewRegister && getError("FullName")}
      
      {isNewRegister && <input id="SiteName" type="textBox" placeholder={getSiteName()} value={user.siteName} 
        onChange={(e)=> setUser({...user, siteName:e.target.value})}
        onBlur={(e) => fireOtherEvent(e, {id:"SiteName", name:getSiteName() }, [{type :"REQUIRE"}])}
        onKeyPress={(e) => fireEventKeyPress(e, {id:"SiteName" }, [{type :"NOSPACE"},{type :"NOSPECIALCHAR"}])}
        className="input connexionInput" />}
      { isNewRegister && getError("SiteName")}
      {<input id="Email" type="textBox" placeholder="Email" value={user.email} 
        readOnly={user.log && user.log.activeResendEmail} 
        onChange={(e)=> setUser({...user, email:e.target.value})}
        onBlur={(e) => fireOtherEvent(e, {id:"Email", name:"Email" }, [{type :"REQUIRE"}, {type :"EMAIL"}])}
        onKeyPress={(e) => fireEventKeyPress(e, {id:"Email" })}
        className="input connexionInput" />}
      {isNewRegister && getError("Email")}
      {isNewRegister && <input id="Password" type="password"  placeholder="Password" value={user.password} 
        autoComplete="off"
        onChange={(e)=> setUser({...user, password:e.target.value})}
        onBlur={(e) => fireOtherEvent(e, {id:"Password", name:"Password" }, [{type :"REQUIRE"}])}
        onKeyPress={(e) => fireEventKeyPress(e, {id:"Password" })}
        className="input connexionInput" />}   
      {isNewRegister && getError("Password")}
      {isNewRegister && <input id="ConfirmPassword" type="password"  placeholder="Confirm Password" value={user.confirmPassword} 
        autoComplete="off"
        onChange={(e)=> setUser({...user, confirmPassword:e.target.value})}
        onBlur={(e) => fireOtherEvent(e, {id:"ConfirmPassword", name:"Confirmation" }, [{type :"REQUIRE"}])}
        onKeyPress={(e) => fireEventKeyPress(e, {id:"ConfirmPassword" })}
        className="input connexionInput" />}           
      {isNewRegister && getError("ConfirmPassword")}
      {isNewRegister && <div style = {{ textAlign:"center", display:"flex" , marginBottom:"5px" }}>
        <CheckBox checked={user.signed} click={() => setUser({...user, signed:!user.signed})} />
        <span style = {{ fontSize:"11px", color:"gray", marginTop:"5px", marginRight:"5px" }} >I accept the</span>
        <Link  style = {{ textDecoration: "none", marginRight:"5px"  }}to="/register">
          <span style = {{ fontSize:"11px", color:"#008dff" }} >Terms of Use</span>
        </Link>
        <span style = {{ fontSize:"11px", color:"gray", marginTop:"5px", marginRight:"5px" }} >&</span>
        <Link  style = {{ textDecoration: "none", marginRight:"5px"  }}to="/register">
          <span style = {{ fontSize:"11px", color:"#008dff" }} >Privacy Policy</span>
        </Link>
      </div>}
      <div style = {{ textAlign:"center", display:"flex" , marginBottom:"5px" }}>
        <input disabled={!canClick} 
          type="button" className="button" 
          style = {{ height:"30px", width: user.log && user.log.activeResendEmail ? "120px" : "250px"
          , marginTop:"10px", backgroundColor:canClick ? "#008dff" : "lightGray" }} 
          value={user.log && user.log.activeResendEmail ? "Resend Email" : "Register" }
          onClick = {(e) => onCreate(e)} 
        />
        {user.log && user.log.activeResendEmail && <input disabled={!canClick} 
          type="button" className="button" 
          style = {{ height:"30px", width:"120px", marginTop:"10px"
          , marginLeft:"10px"
          , backgroundColor:canClick ? "#008dff" : "lightGray" }} 
          value= "New" 
          onClick = {(e) => refreshForm()} 
        />}
      </div>  
    </div>
  );
};

/*

<div style = {{ textAlign:"center", display:"flex" }}>
        <Link  style = {{ fontFamily:"Verdana", marginRight:"auto", textDecoration: "none"  }}to="/register">
          <span style = {{ fontSize:"12px", color:"#008dff"}} >Forget password?</span>
        </Link>
        <Link style = {{ fontFamily:"Verdana", marginLeft:"auto", textDecoration: "none"  }} to="/register">
          <span style = {{ fontSize:"12px", color:"yellowGreen" }} >Sign In</span>
        </Link>
      </div>
  */


